export const optionsMecanismos = [
  {
    id: 1,
    label: "Não implementado"
  },
  {
    id: 2,
    label: "Implementado no último ano"
  },
  {
    id: 3,
    label: "Implementado nos últimos 2 anos"
  },
  {
    id: 4,
    label: "Implementado nos últimos 5 anos"
  },
  {
    id: 5,
    label: "Implementado nos últimos 10 anos"
  }
];

export const optionsFequenciaPercepcao = [
  {
    id: 1,
    label: "Frequentemente"
  },
  {
    id: 2,
    label: "Esporadicamente"
  },
  {
    id: 3,
    label: "Pontualmente"
  },
  {
    id: 4,
    label: "Nunca realizou"
  }
];

export const optionsResultPercep = [
  {
    id: 1,
    label:"Superior ao resultado anterior"
  },
  {
    id: 2,
    label: "Inferior ao resultado anterior"
  },
  {
    id: 3,
    label: "Igual ao resultado anterior"
  },
  {
    id: 4,
    label: "Primeiro ano de realização da pesquisa"
  }
];

export const optionsDefTemas = [
  {
    id: 1,
    label: "É realizada por equipe interna"
  },
  {
    id: 2,
    label: "É realizada por consultoria contratada"
  }
]

export const optionsTemas = [
  {
    id: 1,
    label: "Água e Energia"
  },
  {
    id: 2,
    label: "Comunicação e Relacionamento Comunitário"
  },
  {
    id:3,
    label: "Desenvolvimento Local e Futuro dos Territórios"
  },
  {
    id:4,
    label: "Diversidade e Inclusão"
  },
  {
    id:5,
    label: "Educação Ambiental"
  },
  {
    id:6,
    label: "Emprego e Qualificação"
  },
  {
    id:7,
    label: "Plano Social de Fechamento de Mina"
  },
  {
    id:8,
    label: "Impactos Ambientais"
  },
  {
    id:9,
    label: "Saúde e Segurança para a Comunidade"
  },
  {
    id:10,
    label: "Segurança de Barragens e Estruturas de disposição de Rejeitos"
  },
];

export const optionsQntdTemasTrab = [
  {
    id: 1,
    label: "Todos são trabalhados (100%)"
  },
  {
    id: 2,
    label: "Quase todos são trabalhados (entre 70% e 99%)"
  },
  {
    id: 3,
    label: "Alguns temas são trabalhados (entre 50% e 69%)"
  },
  {
    id: 4,
    label: "Poucos temas são trabalhados (menos de 50%)"
  },
  {
    id: 5,
    label: "Os temas prioritários não são trabalhados"
  }
];

export const optionsPercepImplementa = [
  {
    id: 1,
    label:"No último ano"
  },
  {
    id: 2,
    label: "Há mais de dois anos"
  },
  {
    id: 3,
    label: "Há mais de cinco anos"
  },
  {
    id: 4,
    label: "Há mais de dez anos"
  }
]

export const optionsEstagioPlano = [
  {
    id: 1,
    label: "Não temos PFM"
  },
  {
    id: 2,
    label: "Temos apenas diretrizes corporativas para o tema"
  },
  {
    id: 3,
    label: "Temos plano conceitual baseado nas diretrizes corporativas"
  },
  {
    id: 4,
    label: "Temos plano detalhado baseado nas diretrizes corporativas"
  },
  {
    id: 5,
    label: "Temos plano conceitual baseado nos padrões internacionais e/ou do setor"
  },

  {
    id: 6,
    label: "Temos plano detalhado baseado nos padrões internacionais e/ou do setor"
  },
  {
    id: 7,
    label: "A minha empresa trabalha Plano de Fechamento de Mina com as comunidades vizinhas às operações"
  }
]

export const tagsRel ={
  headers:[
      { key: "cnpj", label: "CNPJ"},
      { key: "empresa", label: "Empresa"},
      { key: "ano", label: "Ano"},
      { key: "mecanismoManifComunid", label: "Empresa possui algum mecanismo para recebimento e registro de manifestações da comunidade"},
      { key: "meca0800", label: "Número 0800"},
      { key: "mecaAppMsg", label: "Aplicativo de mensagens instantâneas (ex. Whatsapp)"},
      { key: "mecaAppProp", label: "Aplicativo próprio"},
      { key: "mecaEmail", label: "E-mail"},
      { key: "mecaTelefone", label: "Telefone fixo ou celular"},
      { key: "mecaWebsite", label: "Website"},
      { key: "mecaOutro", label: "Outro"},
      { key: "freqPesqPercep", label: "Com que frequência a sua empresa realiza pesquisa de percepção da comunidade sobre a sua atuação nos territórios?"},
      { key: "percepImplementacao", label: "Quando foi implementada?"},
      { key: "indicadorConfianca", label: "Confiança"},
      { key: "indicadorFavorabilidade", label: "Favorabilidade"},
      { key: "indicadorImagem", label: "Imagem"},
      { key: "indicadorLicenca", label: "Licença"},
      { key: "indicadorReputacao", label: "Reputação"},
      { key: "indicadorSatisfacao", label: "Satisfação"},
      { key: "indicadorOutro", label: "Outro Percepção"},
      { key: "resultadoPesqPercep", label: "Último resultado da pesquisa de percepção da sua empresa junto às comunidades"},
      { key: "mapeamentoTemas", label: "A minha empresa possui mapeamento dos temas prioritários para as comunidades dos territórios de atuação da sua empresa"},
      { key: "temaMetodolUtilizadas", label: "Qual a metodologia utilizada pela sua empresa para definição dos temas prioritários para as comunidades na área de atuação da sua empresa?"},
      { key: "definicaoTemas", label: "Como se dá o processo para definiçãodos temas prioritários?"},
      { key: "consultorias", label: "Consultorias em caso de contratação"},
      { key: "ordemTemas", label: "Temas ordenados por relevâcia"},
      { key: "qntdTemasTrab", label: "Quanto dos temas prioritários para as comunidadessão trabalhados pela sua empresa na estratégia de relacionamento com as comunidades?"},
      { key: "ferramentaMensurarSatisf", label: "Empresa possui ferramenta para mensuração de indicador de satisfação"},
      { key: "ferramentaDetalhamento", label: "Metodologia usada"},
      { key: "planoFechamentoMina", label: "A minha empresa possui Plano de fechamento de mina"},
      { key: "planoFechamentoMinaComent", label: "Comentário sobre PFM"},
      { key: "estagioPlanoFechamento", label: "Em qual estágio se encontra o PFM?"},
      { key: "metodologiaEstagioPlano", label: "Qual a metodologia do PFM?"},
      { key: "observacoes", label: "Observações"},
      { key: "createdAt", label: "Inserido"},
      { key: "updatedAt", label: "Atualizado"},
      
  ]
}